import { paletteColors, Rating, Typography } from '@evaneos/b2b-ui';
import StarIcon from '@evaneos/b2b-ui/icons/StarOutline';
import FaceIcon from '@evaneos/b2b-ui/icons/FaceOutlined';
import FilledCircleIcon from '@evaneos/b2b-ui/icons/Circle';
import EmptyCircleIcon from '@evaneos/b2b-ui/icons/CircleOutlined';
import { useIntl } from 'react-intl';

import { DefinitionList } from '../../../design-system/DefinitionList/DefinitionList';
import { useDossierLayoutInfo } from '../DossierLayoutInfoContext';

type TravellerProfileInfoProps = {
    rating: number | undefined;
    profile: string | undefined;
};

export function TravellerProfileInfo({ rating, profile }: Readonly<TravellerProfileInfoProps>) {
    const { formatMessage } = useIntl();
    const { isFirstColumnNarrow } = useDossierLayoutInfo();

    return (
        <>
            <DefinitionList.Item>
                <DefinitionList.Label
                    id="traveller-profile"
                    icon={<FaceIcon fontSize="small" aria-hidden="true" />}
                    iconOnly={isFirstColumnNarrow}
                >
                    {formatMessage({ id: 'dossier.information.traveller.profile' })}
                </DefinitionList.Label>
                <DefinitionList.StaticValue>
                    {profile && <Typography variant="body2">{profile}</Typography>}
                </DefinitionList.StaticValue>
            </DefinitionList.Item>
            <DefinitionList.Item sx={{ alignItems: 'center' }}>
                <DefinitionList.Label
                    id="evaneos-note"
                    icon={<StarIcon fontSize="small" aria-hidden="true" />}
                    iconOnly={isFirstColumnNarrow}
                >
                    {formatMessage({ id: 'processes.filters.rating' })}
                </DefinitionList.Label>
                <DefinitionList.StaticValue>
                    {rating !== undefined && (
                        <Rating
                            value={rating}
                            readOnly
                            size="small"
                            icon={
                                <FilledCircleIcon
                                    sx={{ fontSize: '10px', color: paletteColors.yellow[600] }}
                                />
                            }
                            emptyIcon={
                                <EmptyCircleIcon
                                    sx={{ fontSize: '10px', color: paletteColors.yellow[600] }}
                                />
                            }
                            sx={{ gap: '3px' }}
                        />
                    )}
                </DefinitionList.StaticValue>
            </DefinitionList.Item>
        </>
    );
}
